import { createContext, useContext } from 'react';
export var TabsContext = /*#__PURE__*/createContext();

if (typeof TabsContext !== 'undefined' && TabsContext && TabsContext === Object(TabsContext) && Object.isExtensible(TabsContext) && !Object.prototype.hasOwnProperty.call(TabsContext, '__filemeta')) {
  Object.defineProperty(TabsContext, '__filemeta', {
    configurable: true,
    value: {
      name: "TabsContext",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/custom-components/Tabs/context.js"
    }
  });
}

export var useTabsContext = function useTabsContext() {
  var context = useContext(TabsContext);

  if (!context) {
    throw new Error("Tab compound component cannot be rendered outside the Tabs component");
  }

  return context;
};

if (typeof useTabsContext !== 'undefined' && useTabsContext && useTabsContext === Object(useTabsContext) && Object.isExtensible(useTabsContext) && !Object.prototype.hasOwnProperty.call(useTabsContext, '__filemeta')) {
  Object.defineProperty(useTabsContext, '__filemeta', {
    configurable: true,
    value: {
      name: "useTabsContext",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/custom-components/Tabs/context.js"
    }
  });
}